import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useStore} from 'vuex';
    import {useRouter} from 'vue-router';
    import {computed, ref, inject, onMounted} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import StrategyHeadlineSelection from '@/profile-creation-wizard/components/for-creation/ui/1_headline/StrategyHeadlineSelection.vue';
    import StrategyHeadlineSide from '@/profile-creation-wizard/components/for-creation/ui/1_headline/StrategyHeadlineSide.vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'StrategyHeadlineStep',
  setup(__props) {

    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();

    const creationFormValidation = inject(DI.creationFormValidation);
    const trackingRepository = inject(DI.trackingRepository);
    const creationForm = ref(store.getters[getters.creationForm]);

    const isStepValid = computed(() => creationFormValidation?.isHeadlineValid(creationForm.value.headline));

    function goNext(): void {
        trackingRepository?.track('headline-input-strategy', {
            headline: creationForm.value.headline,
        });
        next();
    }

    function headlineKeypressEnter(): void {
        if (isStepValid.value) {
            next();
        }
    }

    function next(): void {
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": isStepValid.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createVNode(StrategyHeadlineSelection, {
        title: _unref(msg)('profile.creation.completion.wizard.v2.details.headline.strategy.title'),
        "subtitle-help": _unref(msg)('profile.creation.completion.wizard.v2.details.headline.strategy.help.title'),
        onHeadlineKeypressEnter: headlineKeypressEnter
      }, null, 8, ["title", "subtitle-help"])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(StrategyHeadlineSide)
    ]),
    _: 1
  }, 8, ["is-step-valid"]))
}
}

})